import { geoCoder } from "../../../System/Api/OPEXAPI";

const generateMiles = async (collections, deliveries) => {

    const google = window.google;

    
    const generateMileage = (goVia = false, ni = false) => {
        return new Promise(async (resolve, reject) => {
            const service = new google.maps.DirectionsService();
            let waypoints = [];
    
            const addWaypoints = (items, excludeIndex) => {
                items.forEach((item, index) => {
                    if (index !== excludeIndex) {
                        waypoints.push({
                            location: item.postCode ? `${unescape(item.postCode)} ${unescape(item.country)}` : item,
                            stopover: true
                        });
                    }
                });
            };
    
            addWaypoints(collections, 0);
            addWaypoints(deliveries, deliveries.length -1);
    
            if (goVia) {
                const viaLocation = ni ? 'via:holyhead' : 'via:calais France';
                waypoints.push({ location: viaLocation });
            }
    
            const getLastLocation = (items) => {
                const lastItem = items[items.length - 1];
                return lastItem.postCode ? `${unescape(lastItem.postCode)} ${unescape(lastItem.country)}` : lastItem;
            };

            const getFirstLocation = (items) => {
                const firstItem = items[0];
                return firstItem.postCode ? `${unescape(firstItem.postCode)} ${unescape(firstItem.country)}` : firstItem;
            };
    
            let request = {
                origin: getFirstLocation(collections),
                destination: getLastLocation(deliveries),
                provideRouteAlternatives: true,
                waypoints: waypoints,
                travelMode: google.maps.TravelMode.DRIVING,
                drivingOptions: {
                    departureTime: new Date("2050-01-01"),
                    trafficModel: 'optimistic'
                }
            };
    
            service.route(request, async (response, status) => {
                if (status !== "OK" || !response.routes.length) {
                    return reject("Error with Google Maps Directions Service");
                }
    
                let shortestDistance = response.routes.reduce((shortest, route) => {
                    let routeDistance = route.legs.reduce((total, leg) => total + leg.distance.value, 0) / 1000;
                    return routeDistance < shortest ? routeDistance : shortest;
                }, Number.MAX_VALUE);
    
                let totalMiles = (shortestDistance * 0.621371).toFixed(0);
    
                try {
                    const endLocation = response.routes[0].legs[response.routes[0].legs.length - 1].end_location;
                    const startLocation = response.routes[0].legs[0].start_location;
    
                    const [ startCountry, startPostcode ] = await getCountry(startLocation);
                    const [ endCountry, endPostcode ] = await getCountry(endLocation);

                    
                    resolve({ end: endCountry, start: startCountry, miles: totalMiles, response: response, startPostcode, endPostcode });

                } catch (error) {

                    reject("Error getting country information");

                }
            });
        });
    };
    
    const getCountry = async (location) => {

        const response = await geoCoder(location.lat(), location.lng());
        
        const postalCode = response.data.response.find(r => r.types.includes('postal_code'));
        const countryData = response.data.response.find(r => r.types.includes('country'));

        return [
            countryData ? countryData.address_components[0].short_name : "GB", 
            postalCode ? postalCode.address_components[0].short_name : null
        ];
    };

    try {
        let ec = await generateMileage();

        // Handling '+' in country codes
        if (ec.end.includes('+')) ec.end = 'GB';
        if (ec.start.includes('+')) ec.start = 'GB';

        // Checking for non-GB and non-island locations
        if ((ec.end !== 'GB' || ec.start !== 'GB') && ec.end !== 'ISLANDS' && ec.start !== 'ISLANDS') {
            ec = await generateMileage(true, ec.end === 'IE' || ec.start === 'IE' || ec.end === 'NIE' || ec.start === 'NIE');
        } else {

        }

        return {
            start: ec.start,
            end: ec.end,
            miles: ec.miles,
            noTariff: ec.end === "ISLANDS" || ec.start === "ISLANDS",
            directions: ec.response,
            startPostcode: ec.startPostcode,
            endPostcode: ec.endPostcode,
        };
    } catch (e) {
        throw new Error("Error in generateMiles: " + e.message);
    }
}

export default generateMiles
